import {requestUser} from '@/utils/request'

// 卖家注册
export function register(data) {
  return requestUser({
    url: '/seller/register',
    method: 'post',
    data
  })
}

// 个体经营者 - 店铺申请
export function individualOperationApply(data) {
  return requestUser({
    url: '/shelfApplicationRecord/individualOperationApply',
    method: 'post',
    data
  })
}

// 企业 - 店铺申请
export function enterpriseApply(data) {
  return requestUser({
    url: '/shelfApplicationRecord/enterpriseApply',
    method: 'post',
    data
  })
}

// 货架申请-货架名称、货主名称、货主邮箱 是否重复校验
export function shelfCheckUnique(data) {
  return requestUser({
    url: `/shelfApplicationRecord/checkUnique`,
    method: 'post',
    data
  })
}

// 店铺申请列表
export function getApplicationRecord(data) {
  return requestUser({
    url: `/shelfApplicationRecord/page`,
    method: 'post',
    data
  })
}

// 判断是否有待审核的店铺申请
export function getApplicationDetails(data) {
  return requestUser({
    url: `/shelfApplicationRecord/getOne`,
    method: 'post',
    data
  })
}

// 邀请链接中对应的参数
export function selectRegisterParam(data) {
  return requestUser({
    url: `/seller/selectRegisterParam`,
    method: 'post',
    data
  })
}

// 驳回 通过key回显数据
export function selectRefuseUrlDetail(data) {
  return requestUser({
    url: `/shelfApplicationRecord/selectRefuseUrlDetail`,
    method: 'post',
    data
  })
}

export function downloadShelfApplicationTemplate(data) {
  return requestUser({
    url: '/shelfApplicationRecord/downloadTemplate',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 判断操作员给操作员 入驻 入口
export function selectLinkShop(data) {
  return requestUser({
    url: `/seller/selectLinkShop`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/register.js